import React,{PureComponent,Fragment} from 'react';
import {Tabs,Badge,  Tooltip,} from 'antd';
import PageCommon from  "@components/PageCommon/PageCommon";
import { Link } from "react-router-dom"
import {postDeliveryList, postDeliveryListInfo, postBatchDelivery,downloadDeliverOrder} from '@/api/warehouseManagement/outWarehouse';
import {postWaitIntoWarehouseList, postInserIntoWarehouse} from '@/api/warehouseManagement/registration'
import VipLvLevel from "@components/Icon/vip-badge/vipLvLevel";
import { toFixedWithCommas} from "@utils/number-util";
import IconVerified from "@components/Icon/IconVerified";
import {isEmpty,trim, toFixed2,formatNumberToPrice,symbolMoneyUtil,getWeek,getIntlYYMMDD} from '@utils/utils';
import CustomerEmailStatus from "@components/customerEmailStatus/customerEmailStatus";
import eventProxy from '@/utils/eventProxy';
import Lang from "@/components/Lang/Lang";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import CustomerList from './components/List';
import NewBuyerLabelAndHistoryDrawer from "@components/StatuLabel/NewBuyerLabelAndHistoryDrawer"
import AllocationFollowUserBtn from "./components/AllocationFollowUserBtn"
import Cookie from "../../../utils/cookie";
import './CustomerIndex.less' ;
import FollowAction from "../Follow/Follow.action";

class CustomerIndex extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            loading:false,
            waitIntoNum: "",
            tabKay: '-10',
            // 表单 配置
            searchFormOptions:[
                {
                    name:'foreignUserId',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'请选择跟进人',
                    cnPlaceholderId:'QingXuanZeGenJinRen',
                    width:180,
                    type:"SearchSelect",
                    searchClass:{
                        api:"/service/mg/follower/search/foreign",
                    },
                },
                {
                    name:'contactWay',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'搜索客户名称/编号/联系电话/邮箱',
                    cnPlaceholderId:'SouSuoKeHuMingChengBianHa2',
                    width:355,
                },
            ],
            tabOptions:[
                {
                    key:'-10',
                    name:Lang({id:"QuanBu", default:"全部"}),
                    // count:'allBuyerTotal',
                },
                {
                    key:'10',
                    name:Lang({id:"DaiChuBuLianXi", default:"待初步联系"}),
                    count:'waitContactBuyerTotal',
                },
                {
                    key:'20',
                    name:Lang({id:"BaoChiDuiHua", default:"保持对话"}),
                    count:'keepTalkBuyerTotal',
                },
                {
                    key:'30',
                    name:Lang({id:"XuanPin", default:"选品"}),
                    count:'addToCartBuyerTotal',
                },
                {
                    key:'40',
                    name:Lang({id:"XiaDan2", default:"下单"}),
                    count:'hasOrderBuyerTotal',
                },
                {
                    key:'50',
                    name:Lang({id:"ChengJiaoShiXian", default:"成交实现"}),
                    count:'confirmOrderBuyerTotal',
                },
                {
                    key:'60',
                    name:Lang({id:"ChengJiaoWeiShiXian", default:"成交未实现"}),
                    count:'cancelOrderBuyerTotal',
                },
            ]
        }
    }

    tabsOnChange(key) {
        this.setState({
            tabKay: key,
        },() => {
            this.onPageListChild.reRefreshSearch();
        })
    }
    // 查询回调
    fetchCallBack(res){
        // const {success,valid,model,paging} = res;

    }
    onRefListOne = (ref) =>  this.onPageListChild = ref;
    componentDidMount() {
        eventProxy.on('redirectPage', (path) => { //不知道为啥，旧代码有此逻辑，先加上
            this.props.history.replace(path)
        })
        const optionExtra  = Cookie.getJSON("fmg.extra") || {};
        this.setState(
            {
                optionExtra: optionExtra,
                fxUserId: optionExtra.fxUserId
            },
            () => {
            }
        );
    }
    searchReset(){
        this.setState({
            abnormalTakeTimeSort:''
        },()=>this.onRefAutoFetchListChrld.handleFetch(1,false))
    }
    /**
     * 客户列表统计
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#8298
     */
    getStatistics() {
        FollowAction.postAction("/service/mg/follower/list/statistics",{
            tapType: -10,//tap页类型 -10:新客列表 20:成交客户列表
        }).then(res=>this.geStatisticsRes(res.data)).catch(err=>this.geStatisticsRes(err));
    }
    geStatisticsRes(res={}){
        const {success,valid,model,} = res;
        if (success && valid) {
            this.setState({
                tabsNums:model||{}
            })
        }
    }
    getColumns(tabKay){
        let otherTitle = "";
        switch (tabKay) {
            case "30":
                otherTitle = Lang({id: "ZuiJinJiaGou", default: "最近加购"});
                break;
            case "40":
                otherTitle = Lang({id: "JiaRuShiJian", default: "下单时间"});
                break;
            case "50":
                otherTitle = Lang({id: "QueRenDingDan", default: "确认订单"});
                break;
            case "60":
                otherTitle = Lang({id: "QuXiaoDingDan", default: "取消订单"});
                break;
            default:
                otherTitle = Lang({id: "ZuiJinFangWen", default: "最近访问"});
        }
        return [
            {
                // cnTitle: '客户信息',
                // cnTitleId: 'KeHuLieBiao',
                title: Lang({id: "KeHuLieBiao", default: "客户信息"}),
                dataIndex: 'buyerCode',
                width: 180,
                render:(text, item, index) => (<Tooltip placement="bottomLeft"
                                                        zIndex={9}
                                                        title={<div className={"black89 intoBox"}>
                                                            <div className={"mb_4 flex-item-ver-center"}>{Lang({id:"DianZiYouXiangYongHuZhang",default:"电子邮箱/用户账号"})}<span className={"ml_16 black66 mr_16"}>{item.email||-""}</span>
                                                                <CustomerEmailStatus verifyEmailStatus={item.verifyEmailStatus+""} />
                                                            </div>

                                                            <div className={"mb_4"}>{Lang({id:"ShouJi",default:"手机"})}<span className={"ml_16 black66"}>{item.telCode?<span className={"mr_4"}>+{item.telCode}</span>:""} {item.mobile||"--"}</span></div>
                                                            <div className={"mb_4"}>{Lang({id:"GongSiLeiXing",default:"公司类型"})}<span className={"ml_16 black66"}>{item.companyType||"--"}</span></div>
                                                            <div className={"flex-item"}>{Lang({id:"JingYingLeiMu",default:"经营类目"})}<span className={"ml_16 black66 flex-1"}>{item.mainCategoryName||"--"}</span></div>
                                                            <div className={"mb_4 flex-item"}>{Lang({id:"GenJinJiLu",default:"跟进记录"})}<div className={"ml_16 black66 flex-1"}>
                                                                {
                                                                    !isEmpty(item.lastFollowDays)?<div className={"flex-item flex-item-ver-center"}>
                                                                        {/* {0} 天前跟进过 今天跟进过*/}
                                                                        <span>{item.lastFollowDays>0?Lang({id:"NTianQianGenJinGuo",default:`${item.lastFollowDays} 天前跟进过`,params:[item.lastFollowDays]}):Lang({id:"JinTianGenJinGuo",default:"今天跟进过"})}</span>
                                                                        {/* 下次跟进 4月22日 周一 (5天后) | 下次跟进 {0}*/}
                                                                        {item.nextFollowDays>=0&&item.nextFollowTime&&item.nextFollowTime>0?<Fragment>，
                                                                            <span className={"mr_8"} dangerouslySetInnerHTML={{__html: __getServerLanguage('XiaCiGenJinN', `${getIntlYYMMDD(item.nextFollowTime)+" "+getWeek(item.nextFollowTime)}（<span class="${item.nextFollowDays<0?'text-red':''}">${item.nextFollowDays===0?__getServerLanguage('JinTian'):__getServerLanguage('NTianHou',item.nextFollowDays)}</span>`)+"）。"}}>
                                                                </span>
                                                                        </Fragment>:null}
                                                                    </div>:"--"
                                                                }
                                                            </div></div>
                                                        </div>}
                                                        arrow={false}
                    // trigger={"click"}
                                                        color={"#fff"}
                                                        overlayClassName={"customerTooltips"}>
                    <div className={"hoverBox hoverBoxH"}>
                        <div className={"flex-item-ver-center"}>
                            <Link target={"_blank"}
                                  className="color-blue3 fw_700 font-16"
                                  to={`/customer/detail?id=${item.id}`} >
                                {item.buyerCode||'-'}
                            </Link>
                            {(!isEmpty(item.isTargetCustomer)||item.pointLevel&&item.pointLevel>0)?<span className={"spanLevel ml_4"}>
                                    {!isEmpty(item.isTargetCustomer)?<IconVerified isTargetCustomer={item.isTargetCustomer} />:null}
                                {item.pointLevel&&item.pointLevel>0?<VipLvLevel grade={item.pointLevel} width={24} />:null}
                                </span>:null}
                        </div>
                        {item.name?<div className="fw_500">{item.name}</div>:null}
                        {item.city?<div className="black45">{item.city}</div>:null}
                    </div>
                </Tooltip>),
            },
            {
                // cnTitle: '注册渠道',
                // cnTitleId: 'ZhuCeQuDao',
                title: Lang({id: "ZhuCeQuDao", default: "注册渠道"}),
                dataIndex: 'channelName',
                width: 350,
                render:(code, row, index) => (<>
                    <div className={"mb_4"}>{row.createTime?getIntlYYMMDD(row.createTime):"-"}</div>
                    {/*<Tooltip placement="topLeft" title={<Lang id="TuiGuangFangShi">推广方式</Lang>}>*/}
                    {/*</Tooltip>*/}
                        <div className="fw_500 color-black">{row.promoteModeName||"-"}</div>
                    {/*<Tooltip placement="topLeft" title={<Lang id="TuiGuangQuDao">推广渠道</Lang>}>*/}
                    {/*</Tooltip>*/}
                        <div className="fw_500 color-black">{row.promoteChannelName||"-"}</div>
                    {row.channelSource?<>
                        {row.channelSource.length>42?<Tooltip placement="topLeft" title={<div style={{wordBreak: "break-all"}}>{row.channelSource}</div>}>
                        <div className="fw_500 ellipsis color-black">{row.channelSource}</div>
                    </Tooltip>:<div className="fw_500 color-black">{row.channelSource}</div>}
                        </>:null}
                </>)
            },
            {
                title: otherTitle,
                dataIndex: 'lastAddTime',
                render:(text, row, index) => ((tabKay == "30"||tabKay == "40"||tabKay == "50"||tabKay == "60") ? <>
                    {tabKay == "30" ?<span>{row.lastAddTime && getIntlYYMMDD(row.lastAddTime, "HH:mm")}</span> : null}
                    {tabKay == "40" ?<span>{row.lastOrderTime && getIntlYYMMDD(row.lastOrderTime, "HH:mm")}</span> : null}
                    {tabKay == "50" ?<span>{row.lastConfirmPoTime && getIntlYYMMDD(row.lastConfirmPoTime, "HH:mm")}</span> : null}
                    {tabKay == "60" ?<span>{row.lastCancelOrderTime && getIntlYYMMDD(row.lastCancelOrderTime, "HH:mm")}</span> : null}
                </> : <>
                    <span>{row.lastVisitTime && getIntlYYMMDD(row.lastVisitTime, "HH:mm")}</span>
                </>)
            },
            {
                // cnTitle: '阶段',
                // cnTitleId: 'JieDuan',
                title: Lang({id: "JieDuan", default: "阶段"}),
                dataIndex: 'newBuyerLabelType',
                width: 300,
                render:(newBuyerLabelType, row, index) => {
                    const iMillis =  row.remainderFollowTime || 0;
                    const iHour =  Math.ceil(iMillis/1000/60/60);
                    const iDay = Math.ceil(iHour/24);
                    return (<>
                        <div>
                            <NewBuyerLabelAndHistoryDrawer statusCode={newBuyerLabelType}
                                                           status={row.newBuyerLabelTypeName}
                                                           key={row.id+"_"+index}
                                                           buyerId={row.id}
                                                           reRefreshSearch={()=>{
                                                               this.getStatistics();
                                                               this.onPageListChild.reRefreshSearch(false)}
                                                           }
                                                           labelType={"1010"}//1010:新客标签 1020:成交客户标签
                            />
                        </div>
                        {/* 是否有合同 0:无 1:有 */}
                        {row.hasContract==1?<div className={"mt_4 green font_14"}>{Lang({id: "YiQianHeTong", default: "已签合同"})}</div>:null}
                        {/* CRM 剩余跟进时间 低于且等于 30 天橙色 ，低于且等于 3 天，显示小时*/}
                        {row.remainderFollowTime? <div className={"mt_4 black66"}><i className={"ri-hourglass-fill black33 font_16"} />
                            <span className={iDay<=30?"color_FB7321":""}>
                                        {iHour>72?Math.ceil(iHour/24) +"d":iHour+"h"}
                                </span>
                        </div>:null}
                        <AllocationFollowUserBtn buyerId={row.id}
                                                 reRefreshSearch={()=>this.onPageListChild.reRefreshSearch(false)}
                                                 foreignUserId={row.foreignUserId}
                                                 key={row.id+"_d"+index}
                                                 foreignUserName={row.foreignUserName}  />
                    </>)
                }
            },
        ]
    }
    componentWillMount() {
        this.getStatistics()
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
    };
    render() {
        const {loading, searchFormOptions, tabsNums={}, tabKay, fxUserId, tabOptions=[]} = this.state;
        return (<PageCommon onRef={this.onRefPageCommon}
                        loading={loading}>
                <CommonBreadcrumb list={[
                    {name:Lang({id:"XinKeHu", default:"新客户"})},
                ]}></CommonBreadcrumb>
                <div className={"customerList"}>
                    <Tabs activeKey={tabKay}onChange={this.tabsOnChange.bind(this)}
                        items={
                            tabOptions.map(opt=>{return {
                                key: opt.key,
                                label:( <div className={"flex-item"}>
                                    {opt.name}
                                    {opt.count?<Badge count={tabsNums[opt.count]||0}/>:null}
                                </div>),
                            }} ) }
                    >
                    </Tabs>
                    <CustomerList onRef={this.onRefListOne}
                                   searchFormOptions={searchFormOptions}
                                   precondition={{
                                       tapType: tabKay,
                                   }}
                                  fetchCallBack={(data)=>this.fetchCallBack(data)}
                                  fxUserId={fxUserId}
                                  tabKay={tabKay}
                                  allTabs={tabKay=="-10"}
                                  columns={this.getColumns(tabKay)} />
                </div>
            </PageCommon>
        )
    }
}

export default CustomerIndex
